<template>
  <div>
    <!-- <Header /> -->

    <FlashMessage v-if="this.messages.text != ''" :message="this.messages" />

    <div class="flex">
      <SideBar />

      <div
        class="w-[90%] mx-auto lg:w-full lg:mr-10 mt-10 rounded-3xl overflow-x-auto overflow-y-auto heightfix"
        style="box-shadow: 0px 2px 30px 0px #01b0f926"
      >
        <div class="px-5 lg:px-10 mt-8 pb-4">
          <div
            class="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4"
          >
            <div>
              <h1 class="text-lg font-semibold">
                Assignments
                <span class="text-blue-600">
                  ({{ assignmentInfo?.count || 0 }})
                </span>
              </h1>
              <p class="text-xs text-slate-500 mt-1">
                Manage assignments, submissions and feedback.
              </p>
            </div>
            <div class="flex flex-wrap gap-2">
              <router-link
                :to="{ name: 'OverallFeedback' }"
                class="bg-blues text-white hover:bg-blue-600 font-semibold text-xs px-4 py-2 rounded-xl"
              >
                Feedback
              </router-link>

              <button
                @click="assignmentPopup = true"
                class="bg-blues text-white hover:bg-blue-600 font-semibold text-xs px-4 py-2 rounded-xl"
              >
                + Add Assignment
              </button>
            </div>
          </div>

          <div class="flex flex-col md:flex-row gap-4 mt-6 items-center">
            <div class="relative w-full md:max-w-80">
              <div
                class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-4 w-4 text-gray-400"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                  />
                </svg>
              </div>
              <input
                type="text"
                v-model="searching"
                @input="getdetails(1)"
                placeholder="Search..."
                class="w-full rounded-xl border border-gray-200 bg-white pl-10 pr-10 py-2 text-xs text-gray-700 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
              />
              <button
                v-if="searching"
                @click="clearSearch"
                class="absolute inset-y-0 right-0 pr-3 flex items-center"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-4 w-4 text-gray-400 hover:text-gray-600"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>

            <!-- Sort -->
            <div class="w-full md:max-w-40">
              <select
                v-model="selected_filter"
                @change="filterorder()"
                class="w-full px-4 py-2 rounded-xl text-xs border border-slate-200 bg-white focus:ring-2 focus:ring-blue-500 focus:outline-none"
              >
                <option value="">Sort By</option>
                <option value="title">A → Z</option>
                <option value="-title">Z → A</option>
                <option value="created_at">Newest First</option>
                <option value="-created_at">Oldest First</option>
              </select>
            </div>
            <div class="w-full py-2">
              <div class="flex justify-end items-center">
                <div
                  class="flex rounded-lg border border-gray-200 overflow-hidden bg-white"
                >
                  <button
                    @click="setTab('list')"
                    :class="[
                      'px-3 py-2 text-sm transition-colors',
                      tab === 'list'
                        ? 'bg-blue-50 text-blue-600'
                        : 'text-gray-500 hover:text-gray-700',
                    ]"
                  >
                    <svg
                      class="w-4 h-4"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M4 6h16M4 12h16M4 18h16"
                      />
                    </svg>
                  </button>
                  <button
                    @click="setTab('card')"
                    :class="[
                      'px-3 py-2 text-sm transition-colors border-l border-gray-200',
                      tab === 'card'
                        ? 'bg-blue-50 text-blue-600'
                        : 'text-gray-500 hover:text-gray-700',
                    ]"
                  >
                    <svg
                      class="w-4 h-4"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M4 4h6v6H4V4zm10 0h6v6h-6V4zM4 14h6v6H4v-6zm10 0h6v6h-6v-6z"
                      />
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div v-if="tab === 'list'" class="pb-4">
            <div class="h-full">
              <div
                v-if="loading"
                class="flex items-center justify-center"
                style="height: calc(100vh - 500px) !important"
              >
                <img src="@/assets/newd/loading.gif" alt="" />
              </div>

              <div
                v-else-if="assignmentInfo && assignmentInfo.data.length > 0"
                class="mt-5 space-y-4"
              >
                <div
                  class="w-full overflow-x-auto rounded-xl border border-gray-200 shadow-sm bg-white"
                >
                  <table
                    class="min-w-full divide-y divide-gray-200 text-sm overflow-visible"
                  >
                    <thead class="bg-gray-50 text-blues">
                      <tr>
                        <th
                          scope="col"
                          class="px-6 py-3.5 font-semibold text-center border-b border-r border-gray-200"
                        >
                          Type
                        </th>
                        <th
                          scope="col"
                          class="px-6 py-3.5 font-semibold text-left border-b border-r border-gray-200 w-[260px] lg:w-[300px] xl:w-[350px]"
                        >
                          Title
                        </th>
                        <th
                          scope="col"
                          class="px-6 py-3.5 font-semibold text-center border-b border-r border-gray-200"
                        >
                          Description
                        </th>
                        <th
                          scope="col"
                          class="px-6 py-3.5 font-semibold text-center border-b border-r border-gray-200"
                        >
                          Due Date
                        </th>
                        <th
                          scope="col"
                          class="px-6 py-3.5 font-semibold text-center border-b border-r border-gray-200"
                        >
                          File
                        </th>
                        <th
                          scope="col"
                          class="px-6 py-3.5 font-semibold text-center border-b border-r border-gray-200"
                        >
                          Actions
                        </th>

                        <th
                          scope="col"
                          class="px-6 py-3.5 font-semibold text-center border-b border-gray-200"
                        >
                          Feedback
                        </th>
                      </tr>
                    </thead>
                    <tbody class="divide-y divide-gray-200 bg-white">
                      <tr
                        v-for="(assignment, index) in assignmentInfo.data"
                        :key="assignment.id"
                        class="hover:bg-gray-50/75 transition-colors duration-150"
                      >
                        <td
                          class="px-4 py-2 border-r border-gray-200 text-center whitespace-nowrap"
                        >
                          <router-link
                            :to="{
                              name: 'InstructorAssignmentsSubmitted',
                              params: { assignment_id: assignment.id },
                            }"
                            class="inline-block focus:outline-none"
                          >
                            <!-- <div
                              class="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center"
                            >
                              <svg
                                class="w-5 h-5 text-blue-600"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-width="2"
                                  d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                                />
                              </svg>
                            </div> -->
                            <img
                              class="w-10 h-10 rounded-md border object-cover mx-auto"
                              :src="require('@/assets/new/assignment.png')"
                              alt="Assignment"
                            />
                          </router-link>
                        </td>

                        <td class="px-6 py-2 border-r border-gray-200">
                          <div
                            class="w-[260px] lg:w-[300px] xl:w-[350px] break-words"
                          >
                            <router-link
                              :to="{
                                name: 'InstructorAssignmentsSubmitted',
                                params: { assignment_id: assignment.id },
                              }"
                              class="font-medium text-gray-900 hover:text-blue-600 hover:underline block leading-relaxed"
                            >
                              <span
                                :class="{
                                  'line-clamp-2': expandedTitleIndex !== index,
                                }"
                              >
                                {{ assignment.title }}
                              </span>
                            </router-link>

                            <div
                              v-if="
                                assignment.title &&
                                assignment.title.length > 100
                              "
                              class="mt-1"
                            >
                              <button
                                type="button"
                                @click.stop="toggleTitle(index)"
                                class="text-blue-600 text-xs font-semibold hover:text-blue-800 transition"
                              >
                                {{
                                  expandedTitleIndex === index
                                    ? "Read Less ←"
                                    : "Read More →"
                                }}
                              </button>
                            </div>
                          </div>
                        </td>

                        <td
                          class="px-6 py-2 border-r border-gray-200 text-center whitespace-nowrap"
                        >
                          <div class="flex justify-center">
                            <button
                              type="button"
                              @click.stop="
                                openDescriptionModal(assignment.description)
                              "
                              class="flex items-center gap-1.5 px-3 py-1.5 bg-blue-50 text-blue-700 border border-blue-200 rounded-lg hover:bg-blue-100 transition shadow-sm text-xs font-medium"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                class="h-4 w-4"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                              >
                                <path
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-width="2"
                                  d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                                />
                                <path
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-width="2"
                                  d="M2.458 12C3.732 7.943 7.523 5 12 5c4.477 0 8.268 2.943 9.542 7-1.274 4.057-5.065 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                                />
                              </svg>
                              View
                            </button>
                          </div>
                        </td>

                        <td
                          class="px-6 py-2 border-r border-gray-200 text-center whitespace-nowrap text-gray-600"
                        >
                          <router-link
                            :to="{
                              name: 'InstructorAssignmentsSubmitted',
                              params: { assignment_id: assignment.id },
                            }"
                            class="hover:text-blue-600 hover:underline"
                          >
                            <div
                              class="flex items-center justify-center gap-1.5"
                            >
                              <svg
                                class="w-4 h-4 text-gray-400"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-width="2"
                                  d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                                />
                              </svg>
                              <span class="text-xs text-gray-600">{{
                                assignment.duedate
                              }}</span>
                            </div>
                          </router-link>
                        </td>

                        <td
                          class="px-6 py-2 border-r border-gray-200 text-center whitespace-nowrap"
                        >
                          <a
                            @click.stop
                            :href="assignment.file"
                            download
                            target="_blank"
                            class="inline-flex items-center gap-1.5 text-xs text-blue-600 hover:text-blue-800"
                          >
                            <svg
                              class="w-4 h-4"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
                              />
                            </svg>
                            Download
                          </a>
                        </td>

                        <td
                          class="px-6 py-2 border-r border-gray-200 text-center whitespace-nowrap overflow-visible"
                        >
                          <div class="flex items-center justify-center gap-4">
                            <button
                              title="Edit"
                              @click.stop="openEditPopup(assignment.id)"
                              class="p-1.5 rounded-lg bg-blue-50 hover:bg-blue-100 transition-all duration-200"
                            >
                              <svg
                                class="w-4 h-4 text-blue-600"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-width="2"
                                  d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                                />
                              </svg>
                            </button>

                            <button
                              title="Delete"
                              @click.stop="
                                titlepass = assignment.title;
                                popupwindow = true;
                                idpass = assignment.id;
                              "
                              class="p-1.5 rounded-lg bg-red-50 hover:bg-red-100 transition-all duration-200"
                            >
                              <svg
                                class="w-4 h-4 text-red-600"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-width="2"
                                  d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                                />
                              </svg>
                            </button>
                          </div>
                        </td>

                        <td class="px-6 py-2 text-center whitespace-nowrap">
                          <div
                            v-if="assignment.is_active"
                            class="flex justify-center"
                          >
                            <span
                              v-if="assignment.assignment_feedback?.total_count"
                            >
                              <router-link
                                class="text-blue-600 hover:text-blue-800 hover:underline font-semibold text-xs"
                                :to="{
                                  name: 'SingleFeedback',
                                  params: { assignment_id: assignment.id },
                                }"
                              >
                                View feedback
                              </router-link>
                            </span>
                            <span
                              v-else
                              class="text-gray-400 font-medium text-xs"
                              >No feedback</span
                            >
                          </div>
                          <span v-else class="text-gray-400">—</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div
                  v-if="total_count > 10"
                  class="flex flex-col sm:flex-row justify-center gap-3 mt-4 relative"
                >
                  <!-- PAGE SIZE -->
                  <div
                    class="md:absolute md:left-3 md:top-2 flex gap-2 text-sm text-gray-600 justify-center items-center"
                  >
                    <span class="flex md:hidden">Rows per page:</span>
                    <select
                      v-model="pageSize"
                      @change="onPageSizeChange"
                      class="border rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                    >
                      <option :value="10">10</option>
                      <option :value="20">20</option>
                      <option :value="50">50</option>
                      <option :value="100">100</option>
                    </select>
                  </div>

                  <!-- PAGINATION -->
                  <div class="flex justify-center">
                    <Pagination
                      :totalPages="totalPages"
                      ref="studentPagination"
                      @page-changed="getdetails"
                    />
                  </div>
                </div>
              </div>

              <!-- <div v-else class="text-gray-500 mt-5">No data found</div> -->

              <div
                v-else
                class="flex flex-col justify-center"
                style="height: calc(100vh - 500px) !important"
              >
                <p class="flex justify-center">No Data Found</p>
              </div>
            </div>
          </div>
          <div v-else-if="tab === 'card'">
            <div
              v-if="loading"
              class="flex items-center justify-center"
              style="height: calc(100vh - 350px) !important"
            >
              <img src="@/assets/newd/loading.gif" alt="" />
            </div>
            <div
              v-else-if="assignmentInfo && assignmentInfo.data.length > 0"
              class="mt-5"
            >
              <div
                class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-5 gap-5"
              >
                <div
                  v-for="assignment in assignmentInfo.data"
                  :key="assignment.id"
                  class="group relative bg-white border border-gray-200 rounded-2xl p-5 flex flex-col justify-between transition-all duration-300 hover:shadow-lg hover:border-blue-100 cursor-pointer"
                >
                  <router-link
                    :to="{
                      name: 'InstructorAssignmentsSubmitted',
                      params: { assignment_id: assignment.id },
                    }"
                    class="block"
                  >
                    <div
                      class="relative overflow-hidden rounded-xl bg-gray-50 aspect-video flex items-center justify-center"
                    >
                      <img
                        class="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                        src="@/assets/new/assignment.png"
                        alt="Assignment Illustration"
                      />
                    </div>
                    <div class="py-4">
                      <h3 class="font-semibold text-gray-900 line-clamp-1">
                        {{ assignment.title }}
                      </h3>
                      <p
                        class="text-[12px] leading-normal text-gray-500 mt-1 line-clamp-2"
                      >
                        {{ assignment.description || "No description" }}
                      </p>
                      <div
                        class="flex items-center gap-1.5 mt-3 text-xs text-gray-500"
                      >
                        <svg
                          class="w-3.5 h-3.5"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                          />
                        </svg>
                        <span>Due: {{ assignment.duedate }}</span>
                      </div>
                    </div>
                  </router-link>
                  <div class="flex items-center justify-between gap-2">
                    <a
                      :href="assignment.file"
                      download
                      target="_blank"
                      class="inline-flex items-center gap-1.5 text-xs font-medium text-blue-600 hover:text-blue-800"
                    >
                      <svg
                        class="w-3.5 h-3.5"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
                        />
                      </svg>
                      Download
                    </a>
                    <div class="flex items-center gap-1">
                      <button
                        title="Edit"
                        @click="openEditPopup(assignment.id)"
                        class="p-1.5 text-gray-500 hover:text-blue-600 rounded-lg hover:bg-blue-50"
                      >
                        <svg
                          class="w-3.5 h-3.5"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                          />
                        </svg>
                      </button>
                      <button
                        title="Delete"
                        @click="
                          titlepass = assignment.title;
                          popupwindow = true;
                          idpass = assignment.id;
                        "
                        class="p-1.5 text-gray-500 hover:text-red-600 rounded-lg hover:bg-red-50"
                      >
                        <svg
                          class="w-3.5 h-3.5"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                          />
                        </svg>
                      </button>
                    </div>
                  </div>
                  <div
                    v-if="
                      assignment.is_active &&
                      assignment.assignment_feedback?.total_count
                    "
                    class=""
                  >
                    <router-link
                      :to="{
                        name: 'SingleFeedback',
                        params: { assignment_id: assignment.id },
                      }"
                      class="inline-flex items-center gap-1.5 text-xs hover:underline font-medium text-blue-600 hover:text-blue-800"
                    >
                      <svg
                        class="w-3.5 h-3.5"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                        />
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M2.458 12C3.732 7.943 7.523 5 12 5c4.477 0 8.268 2.943 9.542 7-1.274 4.057-5.065 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                        />
                      </svg>
                      View Feedback
                    </router-link>
                  </div>
                </div>
              </div>
              <div
                v-if="total_count > 10"
                class="flex flex-col sm:flex-row justify-center gap-3 mt-4 relative"
              >
                <!-- PAGE SIZE -->
                <div
                  class="md:absolute md:left-3 md:top-2 flex gap-2 text-sm text-gray-600 justify-center items-center"
                >
                  <span class="flex md:hidden">Rows per page:</span>
                  <select
                    v-model="pageSize"
                    @change="onPageSizeChange"
                    class="border rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                  >
                    <option :value="10">10</option>
                    <option :value="20">20</option>
                    <option :value="50">50</option>
                    <option :value="100">100</option>
                  </select>
                </div>

                <!-- PAGINATION -->
                <div class="flex justify-center">
                  <Pagination
                    :totalPages="totalPages"
                    ref="studentPagination"
                    @page-changed="getdetails"
                  />
                </div>
              </div>
            </div>
            <div
              v-else
              class="flex flex-col justify-center"
              style="height: calc(100vh - 500px) !important"
            >
              <p class="flex justify-center">No Data Found</p>
            </div>
          </div>
          <!-- Add popup -->
          <div
            v-if="this.assignmentPopup"
            class="fixed inset-0 bg-black bg-opacity-40 z-50 flex items-center justify-center"
          >
            <div
              class="2xl:w-[30%] md:w-[70%] w-[92%] bg-white rounded-xl p-5 max-h-[90vh] overflow-y-auto"
            >
              <!-- Header -->
              <div
                class="flex items-center justify-between pb-3 border-b border-gray-200"
              >
                <h3
                  class="text-base font-bold text-gray-800 flex items-center gap-2"
                >
                  <svg
                    class="w-4 h-4 text-blue-600"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M12 4v16m8-8H4"
                    />
                  </svg>
                  Add Assignment
                </h3>
                <button
                  @click="closePopup"
                  class="p-1.5 rounded hover:bg-gray-100"
                >
                  <svg
                    class="w-4 h-4 text-gray-500"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </button>
              </div>

              <form
                ref="addassignmentRef"
                @submit.prevent="checkPercentage"
                class="flex flex-col gap-3 mt-3"
              >
                <!-- Two Column Grid -->
                <div class="grid grid-cols-1 gap-3">
                  <!-- Left Column -->
                  <div class="flex flex-col gap-3">
                    <!-- Title -->
                    <div class="flex flex-col gap-1">
                      <label
                        for="title"
                        class="text-xs font-medium text-gray-700"
                      >
                        Title <span class="text-red-500">*</span>
                      </label>
                      <input
                        id="title"
                        type="text"
                        required
                        class="border border-gray-300 rounded-lg text-xs px-3 py-2 outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
                        placeholder="Enter assignment title"
                      />
                    </div>

                    <!-- Submit Date -->
                    <div class="flex flex-col gap-1">
                      <label
                        for="duedate"
                        class="text-xs font-medium text-gray-700"
                      >
                        Submit Date <span class="text-red-500">*</span>
                      </label>
                      <input
                        id="duedate"
                        type="date"
                        :min="today"
                        required
                        class="border border-gray-300 rounded-lg text-xs px-3 py-2 outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
                      />
                    </div>

                    <!-- Plagiarism Check -->
                    <div class="flex flex-col gap-1">
                      <label class="text-xs font-medium text-gray-700">
                        Plagiarism Check
                      </label>
                      <div class="flex items-center gap-4">
                        <label
                          class="flex items-center gap-1.5 text-xs cursor-pointer"
                        >
                          <input
                            type="radio"
                            name="plagiarism_check"
                            value="true"
                            class="w-3.5 h-3.5 text-blue-600"
                          />
                          On
                        </label>
                        <label
                          class="flex items-center gap-1.5 text-xs cursor-pointer"
                        >
                          <input
                            type="radio"
                            name="plagiarism_check"
                            value="false"
                            class="w-3.5 h-3.5 text-blue-600"
                            checked
                          />
                          Off
                        </label>
                      </div>
                    </div>

                    <!-- Published -->
                    <div class="flex items-center gap-2 pt-1">
                      <input
                        id="publish"
                        type="checkbox"
                        class="w-3.5 h-3.5 text-blue-600 rounded border-gray-300"
                      />
                      <label
                        for="publish"
                        class="text-xs font-medium text-gray-700 cursor-pointer"
                      >
                        Published
                      </label>
                    </div>
                  </div>

                  <!-- Right Column -->
                  <div class="flex flex-col gap-3">
                    <!-- Description -->
                    <div class="flex flex-col gap-1">
                      <label
                        for="description"
                        class="text-xs font-medium text-gray-700"
                      >
                        Description
                      </label>
                      <textarea
                        id="description"
                        rows="3"
                        class="border border-gray-300 rounded-lg text-xs px-3 py-2 outline-none resize-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
                        placeholder="Enter description"
                      ></textarea>
                    </div>

                    <!-- Attachments -->
                    <div class="flex flex-col gap-1">
                      <label
                        for="files"
                        class="text-xs font-medium text-gray-700"
                      >
                        Attachments <span class="text-red-500">*</span>
                      </label>
                      <input
                        id="files"
                        type="file"
                        accept=".pdf, .doc, .docx,.xls"
                        class="border border-gray-300 rounded-lg text-xs px-3 py-2 outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500 file:mr-3 file:py-1 file:px-3 file:rounded-lg file:border-0 file:bg-blue-50 file:text-blue-600 file:text-xs hover:file:bg-blue-100"
                        @change="inputchange"
                        required
                      />
                      <p
                        class="text-[10px] text-gray-400 font-medium tracking-tight mt-0.5"
                      >
                        Accepted formats: PDF, DOC, DOCX ,XLS (Max size
                        recommended)
                      </p>
                    </div>
                  </div>
                </div>

                <!-- Full Width Fields -->
                <div class="flex flex-col gap-3 mt-1">
                  <!-- Verification Toggle & Percentage -->
                  <div class="grid grid-cols-1 md:grid-cols-2 gap-3">
                    <!-- Verification Checkbox -->
                    <div class="flex items-center gap-2">
                      <input
                        id="verification_checkbox"
                        type="checkbox"
                        v-model="verificationEnabled"
                        @change="toggleVerification"
                        class="w-3.5 h-3.5 text-blue-600 rounded border-gray-300"
                      />
                      <label
                        for="verification_checkbox"
                        class="text-xs font-medium text-gray-700 cursor-pointer"
                      >
                        Enable Verification
                      </label>
                    </div>

                    <!-- Percentage Input -->
                    <div
                      v-if="verificationEnabled"
                      class="flex items-center gap-2"
                    >
                      <label
                        for="verification_percentage"
                        class="text-xs font-medium text-gray-700 whitespace-nowrap"
                      >
                        Percentage <span class="text-red-500">*</span>
                      </label>
                      <input
                        id="verification_percentage"
                        v-model="verificationPercentage"
                        type="text"
                        required
                        maxlength="2"
                        :disabled="!verificationEnabled"
                        class="w-20 px-2 py-1.5 border border-gray-300 rounded-lg text-xs outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
                        :class="
                          !verificationEnabled &&
                          'bg-gray-100 cursor-not-allowed'
                        "
                        placeholder="0-99"
                        @input="
                          verificationPercentage = verificationPercentage
                            .replace(/\D/g, '')
                            .slice(0, 2)
                        "
                      />
                    </div>
                  </div>

                  <!-- Feedback -->
                  <div class="flex items-center gap-2">
                    <input
                      id="feedback"
                      type="checkbox"
                      v-model="feedback_active"
                      class="w-3.5 h-3.5 text-blue-600 rounded border-gray-300"
                    />
                    <label
                      for="feedback"
                      class="text-xs font-medium text-gray-700 cursor-pointer"
                    >
                      Enable Feedback
                    </label>
                  </div>
                </div>

                <!-- Submit Button -->
                <div
                  class="flex items-center justify-end gap-2 pt-3 border-t border-gray-200 mt-1"
                >
                  <button
                    type="button"
                    @click="closePopup"
                    class="px-4 py-1.5 text-xs font-medium text-gray-600 bg-gray-100 rounded-lg hover:bg-gray-200"
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    :disabled="disable_submit == true"
                    class="px-4 py-1.5 text-xs font-semibold text-white rounded-lg flex items-center gap-2"
                    :class="
                      disable_submit
                        ? 'bg-gray-400 cursor-not-allowed'
                        : 'bg-blue-600 hover:bg-blue-700'
                    "
                  >
                    <svg
                      v-if="!disable_submit"
                      class="w-3.5 h-3.5"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                    {{ disable_submit ? "Submitting..." : "Submit" }}
                  </button>
                  <img
                    v-if="disable_submit"
                    src="@/assets/loading.gif"
                    alt="loading"
                    class="w-5 h-5 object-contain"
                  />
                </div>
              </form>
            </div>
          </div>

          <!-- Edit popup -->
          <div
            v-if="this.isEditing"
            @click.self="this.isEditing = false"
            class="fixed inset-0 bg-black bg-opacity-40 z-50 flex items-center justify-center"
          >
            <div
              class="2xl:w-[30%] md:w-[70%] w-[92%] bg-white rounded-xl p-5 max-h-[90vh] overflow-y-auto shadow-2xl"
            >
              <!-- Header -->
              <div
                class="flex items-center justify-between pb-3 border-b border-gray-200"
              >
                <h3
                  class="text-base font-bold text-gray-800 flex items-center gap-2"
                >
                  <svg
                    class="w-4 h-4 text-blue-600"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                    />
                  </svg>
                  Edit Assignment
                </h3>
                <button
                  @click="this.isEditing = false"
                  class="p-1.5 rounded hover:bg-gray-100 transition-colors duration-200"
                >
                  <svg
                    class="w-4 h-4 text-gray-500"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </button>
              </div>

              <form
                ref="createTeamRef"
                @submit.prevent="checkEditPercentage"
                class="flex flex-col gap-3 mt-3"
              >
                <!-- Two Column Grid -->
                <div class="grid grid-cols-1 gap-3">
                  <!-- Left Column -->
                  <div class="flex flex-col gap-3">
                    <!-- Title -->
                    <div class="flex flex-col gap-1">
                      <label
                        for="title"
                        class="text-xs font-medium text-gray-700"
                      >
                        Title <span class="text-red-500">*</span>
                      </label>
                      <input
                        id="title"
                        type="text"
                        v-model="editassign_list.title"
                        class="border border-gray-300 rounded-lg text-xs px-3 py-2 outline-none transition-all duration-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-200"
                        placeholder="Enter assignment title"
                      />
                    </div>

                    <!-- Submit Date -->
                    <div class="flex flex-col gap-1">
                      <label
                        for="duedate"
                        class="text-xs font-medium text-gray-700"
                      >
                        Submit Date <span class="text-red-500">*</span>
                      </label>
                      <input
                        id="duedate"
                        v-model="editassign_list.duedate"
                        type="date"
                        class="border border-gray-300 rounded-lg text-xs px-3 py-2 outline-none transition-all duration-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-200"
                      />
                    </div>

                    <!-- Plagiarism Check -->
                    <div class="flex flex-col gap-1">
                      <label class="text-xs font-medium text-gray-700">
                        Plagiarism Check
                      </label>
                      <div class="flex items-center gap-4">
                        <label
                          class="flex items-center gap-1.5 text-xs cursor-pointer hover:text-blue-600 transition-colors duration-200"
                        >
                          <input
                            id="plagiarism_check"
                            type="radio"
                            name="plagiarism_check"
                            v-model="editassign_list.plagiarismcheck"
                            value="true"
                            class="w-3.5 h-3.5 text-blue-600 transition-all duration-200"
                          />
                          On
                        </label>
                        <label
                          class="flex items-center gap-1.5 text-xs cursor-pointer hover:text-blue-600 transition-colors duration-200"
                        >
                          <input
                            id="plagiarism_check"
                            type="radio"
                            name="plagiarism_check"
                            v-model="editassign_list.plagiarismcheck"
                            value="false"
                            class="w-3.5 h-3.5 text-blue-600 transition-all duration-200"
                          />
                          Off
                        </label>
                      </div>
                    </div>

                    <!-- Published -->
                    <div class="flex items-center gap-2 pt-1">
                      <input
                        id="publish"
                        v-model="editassign_list.publish"
                        :checked="editassign_list.publish"
                        type="checkbox"
                        class="w-3.5 h-3.5 text-blue-600 rounded border-gray-300 transition-all duration-200 focus:ring-2 focus:ring-blue-200"
                      />
                      <label
                        for="publish"
                        class="text-xs font-medium text-gray-700 cursor-pointer hover:text-blue-600 transition-colors duration-200"
                      >
                        Published
                      </label>
                    </div>
                  </div>

                  <!-- Right Column -->
                  <div class="flex flex-col gap-3">
                    <!-- Description -->
                    <div class="flex flex-col gap-1">
                      <label
                        for="description"
                        class="text-xs font-medium text-gray-700"
                      >
                        Description
                      </label>
                      <textarea
                        v-model="editassign_list.description"
                        id="description"
                        rows="3"
                        class="border border-gray-300 rounded-lg text-xs px-3 py-2 outline-none resize-none transition-all duration-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-200"
                        placeholder="Enter description"
                      ></textarea>
                    </div>

                    <!-- File -->
                    <div class="flex flex-col gap-1">
                      <label
                        for="assign_file"
                        class="text-xs font-medium text-gray-700"
                      >
                        File <span class="text-red-500">*</span>
                      </label>
                      <input
                        id="assign_file"
                        type="file"
                        accept=".pdf, .doc, .docx ,.xls"
                        class="border border-gray-300 rounded-lg text-xs px-3 py-2 outline-none transition-all duration-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 file:mr-3 file:py-1 file:px-3 file:rounded-lg file:border-0 file:bg-blue-50 file:text-blue-600 file:text-xs hover:file:bg-blue-100"
                        @change="handleFileUpload"
                      />
                      <p
                        class="text-[10px] text-gray-400 font-medium tracking-tight mt-0.5"
                      >
                        Accepted formats: PDF, DOC, DOCX,XLS (Max size
                        recommended)
                      </p>
                      <a
                        v-if="editassign_list.file"
                        :href="editassign_list.file"
                        download
                        target="_blank"
                        class="text-xs text-blue-600 hover:text-blue-700 hover:underline flex items-center gap-1 mt-1 transition-colors duration-200"
                      >
                        <svg
                          class="w-3 h-3"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M15.172 7l-6.586 6.586a2 2 0 102.828 2.828l6.414-6.586a4 4 0 00-5.656-5.656l-6.415 6.585a6 6 0 108.486 8.486L20.5 13"
                          />
                        </svg>
                        {{ editassign_list.file.split("/").pop() }}
                      </a>
                    </div>
                  </div>
                </div>

                <!-- Full Width Fields -->
                <div class="flex flex-col gap-3 mt-1">
                  <!-- Verification Toggle & Percentage -->
                  <div class="grid grid-cols-1 md:grid-cols-2 gap-3">
                    <!-- Verification Checkbox -->
                    <div class="flex items-center gap-2">
                      <input
                        id="verification_checkbox"
                        type="checkbox"
                        v-model="editassign_list.internal_verification"
                        @change="toggleVerification"
                        class="w-3.5 h-3.5 text-blue-600 rounded border-gray-300 transition-all duration-200 focus:ring-2 focus:ring-blue-200"
                      />
                      <label
                        for="verification_checkbox"
                        class="text-xs font-medium text-gray-700 cursor-pointer hover:text-blue-600 transition-colors duration-200"
                      >
                        Enable Verification
                      </label>
                    </div>

                    <!-- Percentage Input -->
                    <div
                      v-if="editassign_list.internal_verification"
                      class="flex items-center gap-2"
                    >
                      <label
                        for="verification_percentage"
                        class="text-xs font-medium text-gray-700 whitespace-nowrap"
                      >
                        Percentage <span class="text-red-500">*</span>
                      </label>
                      <input
                        id="verification_percentage"
                        v-model="editassign_list.percentage"
                        type="text"
                        maxlength="2"
                        class="w-20 px-2 py-1.5 border border-gray-300 rounded-lg text-xs outline-none transition-all duration-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-200"
                        placeholder="0-99"
                        @input="
                          editassign_list.percentage =
                            editassign_list.percentage
                              .replace(/\D/g, '')
                              .slice(0, 2)
                        "
                      />
                      <span class="text-xs text-gray-400">%</span>
                    </div>
                  </div>

                  <!-- Feedback -->
                  <div class="flex items-center gap-2">
                    <input
                      id="feedback"
                      v-model="editassign_list.is_active"
                      type="checkbox"
                      class="w-3.5 h-3.5 text-blue-600 rounded border-gray-300 transition-all duration-200 focus:ring-2 focus:ring-blue-200"
                    />
                    <label
                      for="feedback"
                      class="text-xs font-medium text-gray-700 cursor-pointer hover:text-blue-600 transition-colors duration-200"
                    >
                      Enable Feedback
                    </label>
                  </div>
                </div>

                <!-- Submit Button -->
                <div
                  class="flex items-center justify-end gap-2 pt-3 border-t border-gray-200 mt-1"
                >
                  <button
                    type="button"
                    @click="this.isEditing = false"
                    class="px-4 py-1.5 text-xs font-medium text-gray-600 bg-gray-100 rounded-lg hover:bg-gray-200"
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    :disabled="disable_submit == true"
                    class="px-4 py-1.5 text-xs font-semibold text-white rounded-lg flex items-center gap-2"
                    :class="
                      disable_submit
                        ? 'bg-gray-400 cursor-not-allowed'
                        : 'bg-blue-600 hover:bg-blue-700'
                    "
                  >
                    <svg
                      v-if="!disable_submit"
                      class="w-3.5 h-3.5"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                    {{ disable_submit ? "Updating..." : "Update" }}
                  </button>
                  <img
                    v-if="disable_submit"
                    src="@/assets/loading.gif"
                    alt="loading"
                    class="w-5 h-5 object-contain"
                  />
                </div>
              </form>
            </div>
          </div>

          <!-- delect popup -->

          <div
            v-if="popupwindow"
            class="fixed flex bg-black bg-opacity-70 justify-center items-center inset-0 z-50 outline-none overflow-x-hidden overflow-y-auto"
            style="z-index: 5000"
          >
            <div class="w-[90%] lg:w-[35%] rounded-md m-4">
              <div
                class="relative flex flex-col clear-both justify-center rounded-t-lg w-full pt-12 p-4 md:p-10 bg-white gap-3"
              >
                <img
                  @click="popupwindow = false"
                  class="absolute right-2 top-2 cursor-pointer w-5 h-5 object-contain"
                  src="@/assets/newd/close.png"
                />
                <p class="text-center font-base text-xl text-gray-600">
                  Are you sure want to delete ?
                </p>
                <h1 class="text-center font-bold text-xl text-blues">
                  {{ titlepass }}
                </h1>
              </div>
              <div
                class="body-popup flex flex-col rounded-b-lg py-3 md:py-6 px-3 md:px-6 bg-gray-200"
              >
                <div class="flex gap-4 justify-between w-full md:w-3/4 mx-auto">
                  <button
                    @click="popupwindow = false"
                    class="bg-white hover:bg-gray-300 text-gray-700 cursor-pointer text-sm font-semibold rounded-lg overflow-hidden px-4 py-2"
                  >
                    Cancel
                  </button>
                  <div class="flex items-center gap-3">
                    <button
                      type="submit"
                      @click="deleteAssign"
                      :disabled="disable_submit == true"
                      :class="
                        this.disable_submit == true
                          ? 'bg-white text-black cursor-not-allowed'
                          : ' bg-blues hover:bg-blue-600 cursor-pointer text-white'
                      "
                      class="text-sm font-semibold rounded-lg overflow-hidden px-4 py-2"
                    >
                      Yes
                    </button>

                    <img
                      v-if="disable_submit"
                      src="@/assets/loading.gif"
                      alt="loading"
                      class="w-6 h-6 object-contain"
                    />
                  </div>
                </div>
                <div class="mt-3 flex justify-center items-start gap-2.5 py-1">
                  <!-- Warning Icon -->
                  <svg
                    class="w-4 h-4 text-amber-600 mt-0.5 shrink-0"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                    />
                  </svg>

                  <!-- Text Content -->
                  <p class="text-xs font-medium text-slate-600 leading-normal">
                    <strong class="text-slate-900 font-semibold">Note:</strong>
                    Deleting this assignment is permanent and will notify the
                    Admin.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <!-- Description Modal -->
          <div
            v-if="descriptionModalOpen"
            class="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50 px-4"
          >
            <div
              class="bg-white rounded-2xl shadow-2xl w-full max-w-xl max-h-[90vh] overflow-hidden flex flex-col relative"
            >
              <div
                class="flex items-center justify-between p-5 border-b border-gray-200"
              >
                <h2 class="text-xl font-semibold text-gray-800">
                  Assignment Description
                </h2>
                <button
                  @click="descriptionModalOpen = false"
                  class="text-gray-500 hover:text-red-500 text-2xl"
                >
                  &times;
                </button>
              </div>
              <div
                class="p-6 overflow-y-auto text-sm leading-relaxed whitespace-pre-wrap"
              >
                <!-- v-if / v-else -->
                <p v-if="currentDescription" class="text-gray-700">
                  {{ currentDescription }}
                </p>
                <p v-else class="text-gray-400 font-bold text-center">
                  No data found.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        v-if="showPercentagePopup"
        class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
      >
        <div class="bg-white rounded-xl p-6 w-[400px] max-w-[92%] shadow-xl">
          <!-- Header -->
          <div class="flex items-center justify-between mb-4">
            <div class="flex items-center gap-2">
              <svg
                class="w-5 h-5 text-yellow-500"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  fill-rule="evenodd"
                  d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
                  clip-rule="evenodd"
                />
              </svg>
              <h2 class="text-lg font-semibold text-gray-800">Warning</h2>
            </div>
            <button
              @click="cancelPercentageChange"
              class="text-gray-400 hover:text-gray-600"
            >
              <svg
                class="w-5 h-5"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>

          <!-- Message -->
          <div class="bg-gray-50 rounded-lg p-4 mb-5">
            <p class="text-sm text-gray-700 text-center leading-relaxed">
              Previous Assignment percentage is
              <span
                class="inline-block px-2 py-0.5 mx-1 bg-red-100 text-red-700 font-bold rounded"
              >
                {{ previousPercentage }}%
              </span>
              <br class="sm:hidden" />
              <span class="hidden sm:inline"> </span>
              Do you want to change it to
              <span
                class="inline-block px-2 py-0.5 mx-1 bg-green-100 text-green-700 font-bold rounded"
              >
                {{ verificationPercentage }}%
              </span>
              ?
            </p>
          </div>

          <!-- Buttons -->
          <div
            class="flex flex-col sm:flex-row items-center justify-center gap-3"
          >
            <button
              @click="cancelPercentageChange"
              class="w-full sm:w-auto px-6 py-2 text-sm font-medium text-gray-600 bg-gray-100 rounded-lg hover:bg-gray-200"
            >
              Close
            </button>

            <button
              @click="confirmPercentageChange"
              class="w-full sm:w-auto px-6 py-2 text-sm font-semibold text-white bg-blue-600 rounded-lg hover:bg-blue-700 shadow-sm"
            >
              OK
            </button>
          </div>
        </div>
      </div>
      <div
        v-if="showeditPercentagePopup"
        class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
      >
        <div class="bg-white rounded-xl p-6 w-[400px] max-w-[92%] shadow-xl">
          <!-- Header -->
          <div class="flex items-center justify-between mb-4">
            <div class="flex items-center gap-2">
              <svg
                class="w-5 h-5 text-yellow-500"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  fill-rule="evenodd"
                  d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
                  clip-rule="evenodd"
                />
              </svg>
              <h2 class="text-lg font-semibold text-gray-800">Warning</h2>
            </div>
            <button
              @click="canceleditPercentageChange"
              class="text-gray-400 hover:text-gray-600"
            >
              <svg
                class="w-5 h-5"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>

          <!-- Message -->
          <div class="bg-gray-50 rounded-lg p-4 mb-5">
            <p class="text-sm text-gray-700 text-center leading-relaxed">
              The verification percentage for all existing assignments is
              currently
              <span
                class="inline-block px-2 py-0.5 mx-1 text-red-700 font-bold rounded"
              >
                {{ previousPercentage }}%
              </span>

              <br class="sm:hidden" />

              Changing it to

              <span
                class="inline-block px-2 py-0.5 mx-1 text-green-700 font-bold rounded"
              >
                {{ editassign_list.percentage }}%
              </span>

              will update the verification percentage for all assignments. Do
              you want to continue?
            </p>
          </div>

          <!-- Buttons -->
          <div
            class="flex flex-col sm:flex-row items-center justify-center gap-3"
          >
            <button
              @click="canceleditPercentageChange"
              class="w-full sm:w-auto px-6 py-2 text-sm font-medium text-gray-600 bg-gray-100 rounded-lg hover:bg-gray-200"
            >
              Close
            </button>

            <button
              @click="confirmeditPercentageChange"
              class="w-full sm:w-auto px-6 py-2 text-sm font-semibold text-white bg-blue-600 rounded-lg hover:bg-blue-700 shadow-sm"
            >
              OK
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Instructor/Header.vue";
import SideBar from "@/components/Instructor/SideBar.vue";
import Pagination from "@/components/Pagination.vue";
import FlashMessage from "@/components/FlashMessage.vue";

import axios from "axios";
import { mapGetters } from "vuex";

export default {
  components: {
    Header,
    SideBar,
    FlashMessage,
    Pagination,
  },
  data() {
    return {
      pageSize: 10,
      searching: "",
      selected_filter: "",
      descriptionModalOpen: false,
      currentDescription: "",
      assignmentInfo: null,
      messages: {
        text: "",
        type: "null",
      },
      popupwindow: false,
      titlepass: null,
      idpass: null,
      assignmentPopup: false,
      assignmentEditPopup: false,
      editvalues: null,
      editOptions: false,
      loading: true,
      tab: "list",
      plagiarism_check: false,
      isEditing: false,
      editassignId: null,
      editassign_list: [],
      disable_submit: false,
      totalPages: 1,
      current_page: 1,
      feedback_active: true,
      expandedTitleIndex: null,
      total_count: 0,
      verificationEnabled: false,
      verificationPercentage: "",
      previousmark: {},
      previousPercentage: "",
      showPercentagePopup: false,
      pendingForm: null,
      editEvent: null,
      isEditMode: false,
      showeditPercentagePopup: false,
    };
  },
  created() {
    this.getpercentage();
    this.getdetails(1);
  },

  props: ["course_id"],

  computed: {
    ...mapGetters(["userInfo"]),
    today() {
      return new Date().toISOString().split("T")[0];
    },
  },
  mounted() {
    document.addEventListener("click", this.handleClickOutside);
  },
  beforeUnmount() {
    document.removeEventListener("click", this.handleClickOutside);
  },
  methods: {
    checkEditPercentage(e) {
      if (
        this.previousPercentage &&
        this.editassign_list.internal_verification &&
        this.previousPercentage != this.editassign_list.percentage
      ) {
        this.editEvent = e;
        this.isEditMode = true;
        this.showeditPercentagePopup = true;
        return;
      }

      this.editAssign(e);
    },
    confirmeditPercentageChange() {
      this.showeditPercentagePopup = false;

      if (this.isEditMode) {
        this.editAssign(this.editEvent);
      } else {
        this.scheduleAssignment(this.pendingForm);
      }

      this.isEditMode = false;
    },
    canceleditPercentageChange() {
      this.showeditPercentagePopup = false;
      this.pendingForm = null;
      this.editEvent = null;
      this.isEditMode = false;
    },
    confirmPercentageChange() {
      this.showPercentagePopup = false;
      this.scheduleAssignment(this.pendingForm);
    },
    cancelPercentageChange() {
      this.showPercentagePopup = false;
      this.pendingForm = null;
    },
    closePopup() {
      this.assignmentPopup = false;

      this.verificationEnabled = false;
      this.verificationPercentage = "";

      this.disable_submit = false;
      this.loading = false;

      this.$refs.addassignmentRef.reset();
    },
    async checkPercentage(el) {
      if (
        this.previousPercentage &&
        this.verificationEnabled &&
        this.previousPercentage != this.verificationPercentage
      ) {
        this.pendingForm = el;
        this.showPercentagePopup = true;
        return;
      }

      this.scheduleAssignment(el);
    },
    toggleVerification() {
      if (this.verificationEnabled) {
        this.verificationPercentage = this.previousPercentage;
      } else {
        this.verificationPercentage = "";
      }
    },
    async getpercentage() {
      await axios
        .get(
          `${process.env.VUE_APP_API}/skill-percentage-list/?course__id=${this.course_id}&Key=${this.userInfo.token_key}&title=Assignment`,
        )
        .then((response) => {
          if (response.status == 200) {
            this.previousmark = response.data?.data?.data?.data[0];
            this.previousPercentage = this.previousmark?.percentage || "";

            this.verificationEnabled = false;
            this.verificationPercentage = "";
          } else {
            console.log("catch error");
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    toggleTitle(index) {
      this.expandedTitleIndex =
        this.expandedTitleIndex === index ? null : index;
    },
    clearSearch() {
      this.searching = "";
      this.getdetails(1);
    },
    onPageSizeChange() {
      this.current_page = 1;
      this.$refs.studentPagination?.resetPage?.();
      this.getdetails(1);
    },
    handleClickOutside(event) {
      const select = this.$refs.selectFilter;
      if (select && !select.contains(event.target)) {
        this.selected_filter = "";
      }
    },
    openDescriptionModal(description) {
      this.currentDescription = description;
      this.descriptionModalOpen = true;
    },

    // read more and read less method
    showMore(index, val) {
      if (val == "title") {
        this.assignmentInfo.data[index].visibleTitleLengths += 50;
      } else {
        this.assignmentInfo.data[index].visibleLengths += 50;
      }
    },
    showLess(index, val) {
      if (val == "title") {
        this.assignmentInfo.data[index].visibleTitleLengths = 50;
      } else {
        this.assignmentInfo.data[index].visibleLengths = 50;
      }
    },
    pushDetailPage(id) {
      this.$router.push({
        name: "AssignmentDetail",
        params: { assignment_id: id },
      });
    },
    setTab(view) {
      this.tab = view;
    },
    async scheduleAssignment(el) {
      this.disable_submit = true;
      let fileVal = el.target.elements.files.files[0];
      let urls = `${process.env.VUE_APP_API}/assignment/new/?Key=${this.userInfo.token_key}`;
      let formData = new FormData();
      formData.append("file", fileVal);
      formData.append("title", el.target.elements.title.value);
      formData.append("description", el.target.elements.description.value);
      formData.append("duedate", el.target.elements.duedate.value);
      formData.append("assig_status", "false");
      formData.append("instructor_id", this.userInfo.Instructor_id);
      formData.append("organizes_id", this.userInfo.organizes_id);
      formData.append("course_id", this.course_id);
      formData.append("publish", el.target.elements.publish.value);
      formData.append("is_active", this.feedback_active ? "true" : "false");
      formData.append("percentage", this.verificationPercentage);
      formData.append(
        "internal_verification",
        this.verificationEnabled ? "True" : "False",
      );

      formData.append(
        "plagiarismcheck",
        el.target.elements.plagiarism_check.value,
      );
      await axios
        .post(urls, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          if (response.data.message == "your Assignment added successfully") {
            this.messages = {
              text: "Assignment Added successfully",
              type: "success",
            };

            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
            }, 3000);
            this.$refs.addassignmentRef.reset();
            this.assignmentPopup = false;
            this.getpercentage();
            this.getdetails(this.current_page);
            this.disable_submit = false;
          } else {
            this.messages = {
              text: " Event Faild",
              type: "error",
            };
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
            }, 3000);
          }
        })
        .finally(() => {
          this.disable_submit = false;
          setTimeout(() => {
            this.messages = {
              text: "",
              type: "null",
            };
          }, 3000);
        });
    },
    async getdetails(page) {
      this.current_page = page;
      await axios
        .get(
          `${process.env.VUE_APP_API}/Inst_Assignment/view/?course_id=${this.course_id}&Key=${this.userInfo.token_key}&page=${page}&page_size=${this.pageSize}&search=${this.searching}`,
        )
        .then((response) => {
          if (response.data.data) {
            this.assignmentInfo = response.data.data;
            this.totalPages = response.data.total_page;
            this.total_count = response.data.total;
            this.current_page = response.data.current_page;
            this.assignmentInfo.data.forEach((element) => {
              element["display_date"] = new Date(
                element.duedate,
              ).toLocaleDateString("en-IN", {
                day: "numeric",
                month: "long",
                year: "numeric",
              });
              element["visibleLengths"] = 50;
              element["visibleTitleLengths"] = 50;
            });
          }
        })
        .finally(() => {
          setTimeout(() => {
            this.loading = false;
          }, 1000);
        });
    },
    openEditPopup(id) {
      this.editassignId = id;
      axios
        .get(
          `${process.env.VUE_APP_API}/Inst_Assignment/view/?course_id=${this.course_id}&Key=${this.userInfo.token_key}&id=${id}`,
        )
        .then((response) => {
          if (response.data.data.status == 200) {
            this.editassign_list = response.data.data.data[0];
          } else {
            console.log("got error");
          }
        });

      this.isEditing = true;
    },
    handleFileUpload(event) {
      this.thumbnailFile = event.target.files[0];
    },

    async editAssign(e) {
      this.disable_submit = true;
      let updatedEditInfo = new FormData();
      updatedEditInfo.append("title", e.target.elements.title.value);
      updatedEditInfo.append(
        "description",
        e.target.elements.description.value,
      );
      updatedEditInfo.append(
        "plagiarismcheck",
        e.target.elements.plagiarism_check.value,
      );
      updatedEditInfo.append("duedate", e.target.elements.duedate.value);

      if (this.thumbnailFile) {
        updatedEditInfo.append("file", this.thumbnailFile);
      }

      if (e.target.elements.publish.checked) {
        updatedEditInfo.append("publish", true);
      } else {
        updatedEditInfo.append("publish", false);
      }

      updatedEditInfo.append(
        "is_active",
        this.editassign_list.is_active ? "true" : "false",
      );
      updatedEditInfo.append(
        "internal_verification",
        this.editassign_list.internal_verification ? "True" : "False",
      );
      updatedEditInfo.append("percentage", this.editassign_list.percentage);

      try {
        const response = await axios.put(
          `${process.env.VUE_APP_API}/assignment/updated/${this.editassignId}/?Key=${this.userInfo.token_key}`,
          updatedEditInfo,
        );

        if (response.data.status === 200) {
          this.messages = {
            text: response.data.message,
            type: "success",
          };

          this.isEditing = false;
          this.getpercentage();
          this.getdetails(this.current_page);
        } else {
          this.messages = {
            text: response.data.message || "Update failed.",
            type: "error",
          };
        }
      } catch (error) {
        this.messages = {
          text: error.response?.data?.message || "Something went wrong.",
          type: "error",
        };
      } finally {
        this.disable_submit = false;

        setTimeout(() => {
          this.messages = {
            text: "",
            type: "null",
          };
        }, 2500);
      }
    },
    async deleteAssign() {
      this.disable_submit = true;

      try {
        const response = await axios.delete(
          `${process.env.VUE_APP_API}/assignment/updated/${this.idpass}/?Key=${this.userInfo.token_key}`,
        );

        if (response.data.status === 200) {
          this.messages = {
            text: response.data.message || "Assignment deleted successfully.",
            type: "success",
          };

          this.popupwindow = false;
          this.getdetails(this.current_page);
        } else {
          this.messages = {
            text: response.data.message || "Failed to delete assignment.",
            type: "error",
          };
        }
      } catch (error) {
        this.messages = {
          text:
            error.response?.data?.message ||
            "Something went wrong. Please try again.",
          type: "error",
        };
      } finally {
        this.disable_submit = false;

        setTimeout(() => {
          this.messages = {
            text: "",
            type: "null",
          };
        }, 2500);
      }
    },
    async filterorder() {
      await axios
        .get(
          `${process.env.VUE_APP_API}/Inst_Assignment/view/?course_id=${this.course_id}&ordering=${this.selected_filter}&Key=${this.userInfo.token_key}`,
        )
        .then((response) => {
          if (response.data.data) {
            if (Object.keys(response.data) == "error") {
              console.log("Null");
              this.assignmentInfo = response.data.data;
              this.totalPages = response.data.total_page;
              this.current_page = response.data.current_page;
            } else {
              this.assignmentInfo = response.data.data;
              this.totalPages = response.data.total_page;
              this.current_page = response.data.current_page;
              this.assignmentInfo.data.forEach((element) => {
                element["display_date"] = new Date(
                  element.duedate,
                ).toLocaleDateString("en-IN", {
                  day: "numeric",
                  month: "long",
                  year: "numeric",
                });
                element["visibleLengths"] = 50;
                element["visibleTitleLengths"] = 50;
              });
            }
          }
        });
    },
  },
};
</script>

<style scoped>
.heightfix {
  height: calc(100vh - 170px) !important;
}
</style>
